import {FC, memo} from "react";
import {ReactSVG} from "react-svg";

interface IconTextBlock {
  icon: string
  text: string
}

const IconTextBlock: FC<{ list?: IconTextBlock[]}> = (props) => {
  const {list = []} = props

  return (
    <div className="icon-text-block">
      {list.length
        ? list.map(({icon, text}, index) => {
          return (
            <div className="icon-text-block__item" key={index}>
              <ReactSVG className="svg-icon" src={`/i/svg/${icon}.svg`} wrapper={'span'} />
              <span>{text}</span>
            </div>
          )
        })
        : ''
      }
    </div>
  )
}

export default memo(IconTextBlock)
